import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function OAuthPopup({ open, onClose, onConnectNow }) {
  return (
    <Dialog open={open} onOpenChange={onClose} className="blackdrop-md">
      <DialogContent className="max-w-2xl bg-white text-black text-center ">
        <DialogHeader className="text-center">
          <DialogTitle className="text-black text-xl font-semibold text-center">
            Email Provider Not Connected
          </DialogTitle>
        </DialogHeader>

        <p className="text-gray-700 mt-1 text-center">
          Please complete your OAuth first to launch this campaign.
        </p>

        <DialogFooter className="mt-6 flex items-center justify-center gap-4">
          <Button
            onClick={onClose}
            className="border border-black text-black bg-transparent hover:bg-black hover:text-white rounded-lg px-6"
          >
            Close
          </Button>
          <Button
            onClick={onConnectNow}
            className="border border-black text-black bg-transparent hover:bg-black hover:text-white rounded-lg px-6"
          >
            Connect Now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
